module.exports = __webpack_public_path__ + "static/media/sync_loading_gif.5f78d609.gif";